fragment LicenseInfoFragment on LicenseInfo {
    licenseType
    isPurchased
    numBought
    isUnlimited
    numUsed
    displayName
    canAdd
}
